// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.weatherStack {
  margin-top: auto;
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.weatherCard {
  width: 100%;
  height: 175px;
  position: relative;
  overflow: hidden;
}

.weatherIconImg {
  width: 100%;
  height: 100%;
  object-fit: contain;
  -webkit-user-select: none;
          user-select: none;
  -webkit-user-drag: none;
}


.weatherBg {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
}

.weatherMainText {
  position: absolute;
  top: 22px;
  left: 22px;
  z-index: 2;
  margin: 0;
  color: #fff;
  font-weight: 900;
  font-size: 44px;
}

.weatherIcon {
  position: absolute;
  top: 18px;
  right: 18px;
  z-index: 2;
  width: 76px;
  height: 76px;
}

.weatherIcon svg {
  width: 100%;
  height: 100%;
  display: block;
}

.weatherInfo {
  position: absolute;
  left: 18px;
  right: 18px;
  bottom: 14px;
  z-index: 2;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 16px;
  color: #fff;
}

.weatherInfoLeft p {
  margin: 0;
  line-height: 1.25;
  font-size: 14px;
}

.weatherTextGray {
  opacity: 0.7;
  margin-bottom: 8px !important;
  font-size: 12px !important;
}

.weatherInfoLeft p:last-child {
  font-weight: 800;
  font-size: 16px;
}

.weatherInfoRight {
  margin: 0;
  font-weight: 800;
  font-size: 14px;
  opacity: 0.95;
  white-space: nowrap;
}

.asr-page{
  height: 100vh;
  width: 100%;
  display: flex;
  background: #fff;
  overflow: hidden;
  font-family: Manrope-Regular, system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif;
}

/* Sidebar */
.asr-sidebar{
  width: 320px;
  background: #e6e6e6;
  padding: 22px 18px;
  border-right: 1px solid #ddd;
  display: flex;
  flex-direction: column;
  gap: 18px;
  overflow: auto;
}

.asr-logo{
  height: 100px;
  object-fit: contain;
}

.asr-sidebarTitle{
  margin-left: 25px;
  font-size: 25px;
  font-weight: 700;
  color: #333;
}

/* Metrics */
.asr-metricList{
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-top: 14px;
}

.asr-metricRow{
  display: grid;
  grid-template-columns: 50px 30px 1fr;
  align-items: center;
  gap: 30px;
}

.asr-metricIcon{
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: #f0c7ec;
  display: grid;
  place-items: center;
  color: #b022a2;
  box-shadow: 0 2px 6px rgba(0,0,0,0.12);
}

.asr-metricValue{
  font-size: 28px;
  font-weight: 800;
  color: #b022a2;
}

.asr-metricLabel{
  font-size: 16px;
  color: #444;
}

/* Main */
.asr-main{
  flex: 1 1;
  display: flex;
  flex-direction: column;
  min-width: 0;
}

/* Topbar */
.asr-topbar{
  height: 90px;
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  padding: 0 18px;
  background: #fff;
  border-bottom: 1px solid #f0f0f0;
}

.asr-leftCluster{
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
}

.asr-backBtn{
  width: 42px;
  height: 42px;
  border-radius: 12px;
  border: none;
  background: transparent;
  color: #b022a2;
  font-size: 18px;
  cursor: pointer;
  display: grid;
  place-items: center;
}

.asr-headerTitle{
  color: #b022a2;
  font-size: 25px;
  font-weight: 600;
  white-space: nowrap;
}

.asr-tabsCenter{
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 28px;
}

/* Tabs */
.asr-iconTab{
  border: none;
  background: transparent;
  cursor: pointer;
  padding: 6px 14px;
  border-radius: 12px;
  display: grid;
  justify-items: center;
  gap: 4px;
  -webkit-user-select: none;
          user-select: none;
}

.asr-iconTabIcon{
  width: 40px;
  height: 40px;
  border-radius: 10px;
  display: grid;
  place-items: center;
  color: #333;
  opacity: 0.75;
  font-size: 25px;
}

.asr-iconTabLabel{
  font-size: 16px;
  letter-spacing: 1px;
  font-weight: 800;
  color: #333;
  opacity: 0.75;
}

.asr-iconTab.is-active .asr-iconTabIcon,
.asr-iconTabIcon.is-active{
  color: #b022a2;
  opacity: 1;
}

.asr-iconTab.is-active .asr-iconTabLabel,
.asr-iconTabLabel.is-active{
  color: #b022a2;
  opacity: 1;
}

/* Right cluster */
.asr-rightCluster{
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
}

.asr-intervalWrap{
  display: flex;
  align-items: center;
}

.asr-select{
  height: 34px;
  border-radius: 10px;
  border: 1px solid #eee;
  padding: 0 10px;
  font-weight: 700;
  color: #333;
  outline: none;
  background: #fff;
}

/* Toggle */
.asr-toggleWrap{
  display: flex;
  align-items: center;
  gap: 10px;
}

.asr-toggle{
  width: 46px;
  height: 26px;
  border-radius: 999px;
  position: relative;
  cursor: pointer;
  background: #c8c8c8;
  transition: background 0.2s ease;
}

.asr-toggle.is-on{
  background: #b022a2;
}

.asr-knob{
  width: 22px;
  height: 22px;
  background: #fff;
  border-radius: 50%;
  position: absolute;
  top: 2px;
  left: 2px;
  transition: transform 0.2s ease;
  box-shadow: 0 2px 6px rgba(0,0,0,0.2);
}

.asr-toggle.is-on .asr-knob{
  transform: translateX(18px);
}

.asr-autoText{
  font-size: 12px;
  color: #111;
  font-weight: 800;
}

/* Content row: table + map side by side */
.asr-contentRow{
  flex: 1 1;
  display: grid;
  grid-template-columns: 520px 1fr;
  gap: 16px;
  padding: 18px;
  background: #fff;
  overflow: hidden;
  align-items: stretch;
}

.asr-tablePane{
  height: 100%;
  overflow: auto;
  padding-right: 2px;
}

.asr-mapPane{
  height: 100%;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 14px;
}

.cc-card{
  background: #f2f2f2;
  border-radius: 14px;
  padding: 12px;
  border: 1px solid #e2e2e2;
  box-shadow: 0 2px 6px rgba(0,0,0,0.06);
  width: 100%;
}

.cc-headerRow{
  display: grid;
  grid-template-columns: 56px 1fr 46px 32px 32px;
  gap: 8px;
  align-items: center;
  background: #d9d9d9;
  border-radius: 10px;
  padding: 10px;
  font-weight: 900;
  color: #333;
  font-size: 13px;
}

.cc-head{ opacity: 0.95; }
.cc-codeCol{ text-align: center; }
.cc-numCol{ text-align: center; }

.cc-body{
  margin-top: 10px;
  display: grid;
  gap: 10px;
}

.cc-row{
  display: grid;
  grid-template-columns: 56px 1fr 46px 32px 32px;
  gap: 8px;
  align-items: center;
  background: #ededed;
  border-radius: 12px;
  padding: 10px;
}

.cc-codePill{
  height: 36px;
  border-radius: 10px;
  display: grid;
  place-items: center;
  color: #fff;
  font-weight: 900;
  letter-spacing: 0.5px;
  font-size: 12px;
}

.cc-subject{
  font-weight: 700;
  color: #333;
  font-size: 13px;
}

.cc-total{
  text-align: center;
  font-weight: 900;
  color: #333;
  font-size: 18px;
}

.cc-present{
  text-align: center;
  font-weight: 900;
  color: #1aa34a;
  font-size: 18px;
}

.cc-absent{
  text-align: center;
  font-weight: 900;
  color: #d04444;
  font-size: 18px;
}

.cc-empty{
  padding: 12px 10px;
  border-radius: 12px;
  background: #ededed;
  color: #666;
  font-weight: 700;
  font-size: 13px;
}

.weatherStack{
  display: grid;
  gap: 14px;
}

.weatherCard{
  position: relative;
  border-radius: 16px;
  overflow: hidden;
  min-height: 140px;
}

.weatherBg{
  width: 100%;
  height: 175px;
  display: block;
}

.weatherIcon{
  position: absolute;
  right: 16px;
  top: 18px;
  width: 64px;
  height: 64px;
  display: grid;
  place-items: center;
}

.weatherIconImg{
  width: 60px;
  height: 60px;
  object-fit: contain;
}

.weatherMainText{
  position: absolute;
  left: 18px;
  top: 24px;
  color: #fff;
  font-weight: 900;
  font-size: 44px;
  margin: 0;
}

.weatherInfo{
  position: absolute;
  left: 18px;
  right: 18px;
  bottom: 14px;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  gap: 10px;
  color: #fff;
  font-weight: 700;
}

.weatherInfoLeft p{
  margin: 0;
  line-height: 1.2;
}

.weatherTextGray{
  opacity: 0.85;
  font-weight: 800;
}

.weatherInfoRight{
  margin: 0;
  opacity: 0.95;
  font-weight: 900;
}

/* Responsive: stack table above map */
@media (max-width: 1100px){
  .asr-contentRow{
    grid-template-columns: 1fr;
  }
}

`, "",{"version":3,"sources":["webpack://./src/Components/Room.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAiB;UAAjB,iBAAiB;EACjB,uBAAuB;AACzB;;;AAGA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,UAAU;EACV,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,UAAU;EACV,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,UAAU;EACV,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;EACT,WAAW;AACb;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,2FAA2F;AAC7F;;AAEA,YAAY;AACZ;EACE,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,4BAA4B;EAC5B,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA,SAAS;AACT;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA,WAAW;AACX;EACE,YAAY;EACZ,aAAa;EACb,mCAAmC;EACnC,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;;AAEA,SAAS;AACT;EACE,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,aAAa;AACf;;AAEA;;EAEE,cAAc;EACd,UAAU;AACZ;;AAEA;;EAEE,cAAc;EACd,UAAU;AACZ;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,+BAA+B;EAC/B,qCAAqC;AACvC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA,0CAA0C;AAC1C;EACE,SAAO;EACP,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,sCAAsC;EACtC,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8CAA8C;EAC9C,QAAQ;EACR,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA,UAAU,aAAa,EAAE;AACzB,aAAa,kBAAkB,EAAE;AACjC,YAAY,kBAAkB,EAAE;;AAEhC;EACE,gBAAgB;EAChB,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8CAA8C;EAC9C,QAAQ;EACR,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,SAAS;EACT,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,aAAa;EACb,gBAAgB;AAClB;;AAEA,sCAAsC;AACtC;EACE;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[".weatherStack {\n  margin-top: auto;\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n}\n\n.weatherCard {\n  width: 100%;\n  height: 175px;\n  position: relative;\n  overflow: hidden;\n}\n\n.weatherIconImg {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n  user-select: none;\n  -webkit-user-drag: none;\n}\n\n\n.weatherBg {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 0;\n}\n\n.weatherMainText {\n  position: absolute;\n  top: 22px;\n  left: 22px;\n  z-index: 2;\n  margin: 0;\n  color: #fff;\n  font-weight: 900;\n  font-size: 44px;\n}\n\n.weatherIcon {\n  position: absolute;\n  top: 18px;\n  right: 18px;\n  z-index: 2;\n  width: 76px;\n  height: 76px;\n}\n\n.weatherIcon svg {\n  width: 100%;\n  height: 100%;\n  display: block;\n}\n\n.weatherInfo {\n  position: absolute;\n  left: 18px;\n  right: 18px;\n  bottom: 14px;\n  z-index: 2;\n  display: flex;\n  align-items: flex-end;\n  justify-content: space-between;\n  gap: 16px;\n  color: #fff;\n}\n\n.weatherInfoLeft p {\n  margin: 0;\n  line-height: 1.25;\n  font-size: 14px;\n}\n\n.weatherTextGray {\n  opacity: 0.7;\n  margin-bottom: 8px !important;\n  font-size: 12px !important;\n}\n\n.weatherInfoLeft p:last-child {\n  font-weight: 800;\n  font-size: 16px;\n}\n\n.weatherInfoRight {\n  margin: 0;\n  font-weight: 800;\n  font-size: 14px;\n  opacity: 0.95;\n  white-space: nowrap;\n}\n\n.asr-page{\n  height: 100vh;\n  width: 100%;\n  display: flex;\n  background: #fff;\n  overflow: hidden;\n  font-family: Manrope-Regular, system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif;\n}\n\n/* Sidebar */\n.asr-sidebar{\n  width: 320px;\n  background: #e6e6e6;\n  padding: 22px 18px;\n  border-right: 1px solid #ddd;\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n  overflow: auto;\n}\n\n.asr-logo{\n  height: 100px;\n  object-fit: contain;\n}\n\n.asr-sidebarTitle{\n  margin-left: 25px;\n  font-size: 25px;\n  font-weight: 700;\n  color: #333;\n}\n\n/* Metrics */\n.asr-metricList{\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  margin-top: 14px;\n}\n\n.asr-metricRow{\n  display: grid;\n  grid-template-columns: 50px 30px 1fr;\n  align-items: center;\n  gap: 30px;\n}\n\n.asr-metricIcon{\n  width: 60px;\n  height: 60px;\n  border-radius: 50%;\n  background: #f0c7ec;\n  display: grid;\n  place-items: center;\n  color: #b022a2;\n  box-shadow: 0 2px 6px rgba(0,0,0,0.12);\n}\n\n.asr-metricValue{\n  font-size: 28px;\n  font-weight: 800;\n  color: #b022a2;\n}\n\n.asr-metricLabel{\n  font-size: 16px;\n  color: #444;\n}\n\n/* Main */\n.asr-main{\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n}\n\n/* Topbar */\n.asr-topbar{\n  height: 90px;\n  display: grid;\n  grid-template-columns: 1fr auto 1fr;\n  align-items: center;\n  padding: 0 18px;\n  background: #fff;\n  border-bottom: 1px solid #f0f0f0;\n}\n\n.asr-leftCluster{\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  min-width: 0;\n}\n\n.asr-backBtn{\n  width: 42px;\n  height: 42px;\n  border-radius: 12px;\n  border: none;\n  background: transparent;\n  color: #b022a2;\n  font-size: 18px;\n  cursor: pointer;\n  display: grid;\n  place-items: center;\n}\n\n.asr-headerTitle{\n  color: #b022a2;\n  font-size: 25px;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n.asr-tabsCenter{\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 28px;\n}\n\n/* Tabs */\n.asr-iconTab{\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  padding: 6px 14px;\n  border-radius: 12px;\n  display: grid;\n  justify-items: center;\n  gap: 4px;\n  user-select: none;\n}\n\n.asr-iconTabIcon{\n  width: 40px;\n  height: 40px;\n  border-radius: 10px;\n  display: grid;\n  place-items: center;\n  color: #333;\n  opacity: 0.75;\n  font-size: 25px;\n}\n\n.asr-iconTabLabel{\n  font-size: 16px;\n  letter-spacing: 1px;\n  font-weight: 800;\n  color: #333;\n  opacity: 0.75;\n}\n\n.asr-iconTab.is-active .asr-iconTabIcon,\n.asr-iconTabIcon.is-active{\n  color: #b022a2;\n  opacity: 1;\n}\n\n.asr-iconTab.is-active .asr-iconTabLabel,\n.asr-iconTabLabel.is-active{\n  color: #b022a2;\n  opacity: 1;\n}\n\n/* Right cluster */\n.asr-rightCluster{\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 12px;\n}\n\n.asr-intervalWrap{\n  display: flex;\n  align-items: center;\n}\n\n.asr-select{\n  height: 34px;\n  border-radius: 10px;\n  border: 1px solid #eee;\n  padding: 0 10px;\n  font-weight: 700;\n  color: #333;\n  outline: none;\n  background: #fff;\n}\n\n/* Toggle */\n.asr-toggleWrap{\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.asr-toggle{\n  width: 46px;\n  height: 26px;\n  border-radius: 999px;\n  position: relative;\n  cursor: pointer;\n  background: #c8c8c8;\n  transition: background 0.2s ease;\n}\n\n.asr-toggle.is-on{\n  background: #b022a2;\n}\n\n.asr-knob{\n  width: 22px;\n  height: 22px;\n  background: #fff;\n  border-radius: 50%;\n  position: absolute;\n  top: 2px;\n  left: 2px;\n  transition: transform 0.2s ease;\n  box-shadow: 0 2px 6px rgba(0,0,0,0.2);\n}\n\n.asr-toggle.is-on .asr-knob{\n  transform: translateX(18px);\n}\n\n.asr-autoText{\n  font-size: 12px;\n  color: #111;\n  font-weight: 800;\n}\n\n/* Content row: table + map side by side */\n.asr-contentRow{\n  flex: 1;\n  display: grid;\n  grid-template-columns: 520px 1fr;\n  gap: 16px;\n  padding: 18px;\n  background: #fff;\n  overflow: hidden;\n  align-items: stretch;\n}\n\n.asr-tablePane{\n  height: 100%;\n  overflow: auto;\n  padding-right: 2px;\n}\n\n.asr-mapPane{\n  height: 100%;\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 14px;\n}\n\n.cc-card{\n  background: #f2f2f2;\n  border-radius: 14px;\n  padding: 12px;\n  border: 1px solid #e2e2e2;\n  box-shadow: 0 2px 6px rgba(0,0,0,0.06);\n  width: 100%;\n}\n\n.cc-headerRow{\n  display: grid;\n  grid-template-columns: 56px 1fr 46px 32px 32px;\n  gap: 8px;\n  align-items: center;\n  background: #d9d9d9;\n  border-radius: 10px;\n  padding: 10px;\n  font-weight: 900;\n  color: #333;\n  font-size: 13px;\n}\n\n.cc-head{ opacity: 0.95; }\n.cc-codeCol{ text-align: center; }\n.cc-numCol{ text-align: center; }\n\n.cc-body{\n  margin-top: 10px;\n  display: grid;\n  gap: 10px;\n}\n\n.cc-row{\n  display: grid;\n  grid-template-columns: 56px 1fr 46px 32px 32px;\n  gap: 8px;\n  align-items: center;\n  background: #ededed;\n  border-radius: 12px;\n  padding: 10px;\n}\n\n.cc-codePill{\n  height: 36px;\n  border-radius: 10px;\n  display: grid;\n  place-items: center;\n  color: #fff;\n  font-weight: 900;\n  letter-spacing: 0.5px;\n  font-size: 12px;\n}\n\n.cc-subject{\n  font-weight: 700;\n  color: #333;\n  font-size: 13px;\n}\n\n.cc-total{\n  text-align: center;\n  font-weight: 900;\n  color: #333;\n  font-size: 18px;\n}\n\n.cc-present{\n  text-align: center;\n  font-weight: 900;\n  color: #1aa34a;\n  font-size: 18px;\n}\n\n.cc-absent{\n  text-align: center;\n  font-weight: 900;\n  color: #d04444;\n  font-size: 18px;\n}\n\n.cc-empty{\n  padding: 12px 10px;\n  border-radius: 12px;\n  background: #ededed;\n  color: #666;\n  font-weight: 700;\n  font-size: 13px;\n}\n\n.weatherStack{\n  display: grid;\n  gap: 14px;\n}\n\n.weatherCard{\n  position: relative;\n  border-radius: 16px;\n  overflow: hidden;\n  min-height: 140px;\n}\n\n.weatherBg{\n  width: 100%;\n  height: 175px;\n  display: block;\n}\n\n.weatherIcon{\n  position: absolute;\n  right: 16px;\n  top: 18px;\n  width: 64px;\n  height: 64px;\n  display: grid;\n  place-items: center;\n}\n\n.weatherIconImg{\n  width: 60px;\n  height: 60px;\n  object-fit: contain;\n}\n\n.weatherMainText{\n  position: absolute;\n  left: 18px;\n  top: 24px;\n  color: #fff;\n  font-weight: 900;\n  font-size: 44px;\n  margin: 0;\n}\n\n.weatherInfo{\n  position: absolute;\n  left: 18px;\n  right: 18px;\n  bottom: 14px;\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-end;\n  gap: 10px;\n  color: #fff;\n  font-weight: 700;\n}\n\n.weatherInfoLeft p{\n  margin: 0;\n  line-height: 1.2;\n}\n\n.weatherTextGray{\n  opacity: 0.85;\n  font-weight: 800;\n}\n\n.weatherInfoRight{\n  margin: 0;\n  opacity: 0.95;\n  font-weight: 900;\n}\n\n/* Responsive: stack table above map */\n@media (max-width: 1100px){\n  .asr-contentRow{\n    grid-template-columns: 1fr;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
